/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { useRef, useState } from 'react';
import { useDataConnector } from '@forge/data-connector';
import { v4 as uuid4 } from 'uuid';

import { getBearerTokenFromLS } from '../../../shared/Utils/DataConnectorUtils';

export interface IMeterRequestContext {
  rootNodeId: string;
  context: {
    siteId?: string;
    nodeId?: string;
    providerId: string;
    [key: string]: any;
  };
  headers?: {
    [key: string]: string;
  };
}

export interface IMeterConnectorProps {
  connectorConfig: {
    name: string;
    /* Get Params / Query Params */
    options?: { [key: string]: string };
    /* Route Params*/
    routes?: { [key: string]: string };
  };
  requestContext: IMeterRequestContext;
}

export const useConnectorForMeters = (props: IMeterConnectorProps) => {
  const providerId = props.requestContext.context.providerId;

  const [newUuuid, setUuuid] = useState(uuid4());
  const previousProviderIdInputValue = useRef<string | undefined>(providerId);

  // On providerId change new X-SVCorId generate
  if (previousProviderIdInputValue.current !== providerId) {
    setUuuid(uuid4());
    previousProviderIdInputValue.current = providerId;
  }

  const requestHeaders = props.requestContext.headers
    ? {
        'Content-Type': 'application/json',
        authorization: `Bearer ${getBearerTokenFromLS()}`,
        'X-SVCorId': newUuuid,
        ...props.requestContext.headers
      }
    : {
        'Content-Type': 'application/json',
        'X-SVCorId': newUuuid,
        authorization: `Bearer ${getBearerTokenFromLS()}`
      };

  const route = {
    ...props.connectorConfig.routes,
    rootnodes: props.requestContext.rootNodeId ?? '',
    nodes: props.requestContext.context?.nodeId ?? '',
    sites: props.requestContext.context?.siteId ?? '',
    providerId: props.requestContext.context.providerId
  };
  const dataConnector = useDataConnector(props.connectorConfig.name, {
    headers: requestHeaders,
    params: {
      ...props.connectorConfig.options
    },
    route: route
  });
  return dataConnector;
};
